import { useTranslation } from 'react-i18next';
import { FormikProps } from 'formik';

import {
  StyledText,
  StyledFormGroup,
  StyledInput,
  StyledButton,
  StyledLink,
} from '@selfserve/react-ui';
import { buttonIds, routesPaths } from '@selfserve/react-utils';

import { FormValues } from '../feature/get-started';

interface Props {
  isLoading: boolean;
  formik: FormikProps<FormValues>;
}

export const GetStartedForm = ({
  formik: { handleSubmit, handleChange, handleBlur, values, errors },
  isLoading,
}: Props) => {
  const { t } = useTranslation();
  return (
    <form className="get-started-form" onSubmit={handleSubmit}>
      <StyledFormGroup>
        <StyledInput
          id="email"
          name="email"
          inputLabel={t('get-started.work-email')}
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.email}
          error={!!errors.email}
          formHelperText={errors.email}
          inputProps={{ 'aria-label': t('aria.email') }}
          autoFocus
          fullWidth
        />
      </StyledFormGroup>
      <StyledButton
        id={buttonIds.getStartedContinue}
        className="continue-button"
        type="submit"
        loading={isLoading}
        fullWidth
      >
        {t('common.continue')}
      </StyledButton>
      <div className="login-container">
        <StyledText>
          {`${t('get-started.already-have-an-account')} `}
          <StyledLink id={buttonIds.getStartedLogin} to={routesPaths.LOGIN}>
            {t('common.login')}
          </StyledLink>
        </StyledText>
      </div>
    </form>
  );
};
